import { createContext, useContext } from 'react';
export const FloatingFullContext = createContext(undefined);
export const useFloatingFullContext = () => {
    const context = useContext(FloatingFullContext);
    if (context === undefined) {
        throw new Error('useFloating must be used within a FloatingProvider');
    }
    return context;
};
//# sourceMappingURL=FloatingFullContext.js.map